module.exports = __webpack_public_path__ + "img/detail-transport.a800593a.svg";